module.exports = __webpack_public_path__ + "static/media/pixabayVideo.db5fb259.png";